/**
 * Removes one or more keys from a query object.
 * @param query - The route query object (usually from useRoute().query)
 * @param keysToOmit - One or more query keys to exclude
 * @returns A new object without the omitted keys
 */
export function omitQuery<T extends Record<string, any>, K extends keyof T>(
  query: T,
  keysToOmit: K | K[],
): Omit<T, K> {
  const keys = Array.isArray(keysToOmit) ? keysToOmit : [keysToOmit];

  return Object.fromEntries(
    Object.entries(query).filter(([key]) => !keys.includes(key as K)),
  ) as Omit<T, K>;
}
